export class EmbeddedPeerConnection {
    constructor(target, messageScope) {
        this.target = target;
        this.messageScope = messageScope;
        // TODO: can we inject a listener instead?
        this.controlMessage = null;
        this.signalingMessage = null;
        this.origin = window.origin;
        window.addEventListener("message", (event) => {
            if (event.origin !== this.origin) {
                console.warn(`Rejected message because its origin '${event.origin}' it does not match '${this.origin}'.`);
                return;
            }
            const envelope = event.data;
            if (!envelope || envelope.scope !== messageScope) {
                return;
            }
            switch (envelope.category) {
                case "control" /* EmbeddedMessageCategory.Control */:
                    if (this.controlMessage) {
                        this.controlMessage(envelope.message);
                    }
                    break;
                case "signaling" /* EmbeddedMessageCategory.Signaling */:
                    if (this.signalingMessage) {
                        const messagJson = envelope.message;
                        const message = JSON.parse(messagJson);
                        this.signalingMessage(message);
                    }
                    break;
                default:
                    break;
            }
        }, false);
    }
    sendMessage(message, category) {
        const envelope = { category: category, scope: this.messageScope, message: message };
        const peerWindow = this.target.getTargetWindow();
        if (peerWindow) {
            peerWindow.postMessage(envelope);
        }
        else {
            console.warn('The following message could not be posted because there is no embedded client.', envelope);
        }
    }
    sendControlMessage(message) {
        this.sendMessage(message, "control" /* EmbeddedMessageCategory.Control */);
    }
    sendSignalingMessage(message) {
        const messagJson = JSON.stringify(message);
        this.sendMessage(messagJson, "signaling" /* EmbeddedMessageCategory.Signaling */);
    }
}
//# sourceMappingURL=embedded-peer-connection.js.map